import Navbar  from "../../../NavBar/NavBar.js";
import Footer from "../../../Home/Footer.js"
import Whatsapp from "../../../Home/Whatsapp.js";
import Spinner from "../../../Home/Spinner.js";
import { useEffect } from "react";
import SectionUs2 from "./page_us/Solution-US-2/SectionUs2.js";




const PlafondsMursTendus = () => {
 useEffect(() => {
  // ========= HELPERS =========
  const setMeta = (name, content) => {
    let tag = document.querySelector(`meta[name='${name}']`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", name);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
  };

  const setMetaProperty = (property, content) => {
    let tag = document.querySelector(`meta[property='${property}']`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("property", property);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
  };

  // ========= TITLE =========
  document.title =
    "Plafond Textile Maroc | Acoustique & Écologique – UNIK SYSTEM";

  // ========= BASIC SEO =========
  setMeta(
    "description",
    "Plafonds et murs tendus textile au Maroc avec UNIK SYSTEM : solution écologique, acoustique et design à froid. Idéal pour bureaux, hôtels et commerces. Devis gratuit."
  );

  setMeta(
    "keywords",
    "plafond textile maroc, mur textile tendu maroc, plafond acoustique maroc, toile tendue textile, plafond écologique maroc, mur acoustique maroc, plafond bureau maroc, UNIK SYSTEM textile"
  );

  setMeta("robots", "index, follow");
  setMeta("author", "UNIK SYSTEM");

  // ========= CANONICAL =========
  let canonical = document.querySelector("link[rel='canonical']");
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }
  canonical.setAttribute("href", "https://unik-system.com/plafond-textile-maroc");

  // ========= OPEN GRAPH =========
  setMetaProperty(
    "og:title",
    "Plafond Textile Maroc – Acoustique & Design | UNIK SYSTEM"
  );
  setMetaProperty(
    "og:description",
    "Solutions textiles acoustiques et écologiques pour plafonds et murs au Maroc."
  );
  setMetaProperty(
    "og:image",
    "https://unik-system.com/static/media/IMG-20220428-WA0012.f94e3e350b9db60931b3.jpg"
  );
  setMetaProperty("og:url", "https://unik-system.com/plafond-textile-maroc");
  setMetaProperty("og:type", "website");
  setMetaProperty("og:locale", "fr_FR");

  // ========= TWITTER =========
  setMeta("twitter:card", "summary_large_image");
  setMeta(
    "twitter:title",
    "Plafond Textile Maroc – UNIK SYSTEM"
  );
  setMeta(
    "twitter:description",
    "Plafonds et murs textile acoustiques modernes au Maroc."
  );
  setMeta(
    "twitter:image",
    "https://unik-system.com/static/media/IMG-20220428-WA0012.f94e3e350b9db60931b3.jpg"
  );

  // ========= SCHEMA (LOCAL BUSINESS + SERVICE) =========
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "UNIK SYSTEM",
    url: "https://unik-system.com",
    description:
      "Spécialiste des plafonds et murs tendus textile au Maroc. Solutions acoustiques, écologiques et design.",
    address: {
      "@type": "PostalAddress",
      addressCountry: "MA",
    },
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Solutions Textile",
      itemListElement: [
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Plafond Textile Acoustique"
          }
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Mur Textile Tendu"
          }
        }
      ]
    }
  };

  let script = document.querySelector("#schema-us-textile");
  if (!script) {
    script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "schema-us-textile";
    document.head.appendChild(script);
  }
  script.innerHTML = JSON.stringify(schema);

  // ========= FAQ SCHEMA =========
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "C’est quoi un plafond textile tendu ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "C’est une toile textile tendue à froid qui améliore l’acoustique et apporte un design moderne."
        }
      },
      {
        "@type": "Question",
        name: "Quels sont les avantages du textile ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Le textile est écologique, acoustique, démontable et permet des finitions haut de gamme."
        }
      },
      {
        "@type": "Question",
        name: "Pour quels espaces ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Idéal pour bureaux, hôtels, restaurants et espaces commerciaux."
        }
      }
    ]
  };

  let faqScript = document.querySelector("#faq-schema-us-textile");
  if (!faqScript) {
    faqScript = document.createElement("script");
    faqScript.type = "application/ld+json";
    faqScript.id = "faq-schema-us-textile";
    document.head.appendChild(faqScript);
  }
  faqScript.innerHTML = JSON.stringify(faqSchema);

}, []);


  
    return(
        <div className="body">
            <Spinner/>
            <Navbar/>
            <Whatsapp/>
            <SectionUs2/>
            <Footer/>
        </div>    
    )
};

export default PlafondsMursTendus;